<template>
  <rich-form
    ref="form"
    class="soda-bd-form"
    :model="internalData"
    :options="options"
    :immediateValidate="false"
  >
    <rich-form-group>
      <div
        v-for="(field, index) in fields"
        :key="`${field.modelKey}_${index}`"
        :class="field.className"
        :id="field.modelKey"
      >
        <rich-form-item
          :ref="`formItem_${field.prop}`"
          v-if="checkVisible(field)"
          :field="field"
        >
          <div
            class="rich-form-label"
            slot="label"
            v-if="field.type === 'upload'"

            v-show="field.label"
          >
            <div>
              <span
                >{{ field.label
                }}<span class="counts">{{ computeCounts(field) }}</span></span
              >
              <!-- 上传照片的描述 -->
              <p v-if="field.desc" class="desc">{{ field.desc }}</p>
            </div>
            <span
              v-if="field.exampleUrl"
              class="link"
              @click="showPic(field.exampleUrl)"
              >{{ gettext("查看示例") }}</span
            >
          </div>
          <div class="rich-form-label" slot="label" v-else v-show="field.label">
            <span
              >{{ field.label }}<br /><span
                v-if="field.subTitle"
                class="subTitle"
                v-html="field.subTitle"
              ></span
            ></span>
            <span
              v-if="field.exampleUrl"
              class="link"
              @click="showPic(field.exampleUrl)"
              >{{ gettext("查看示例") }}</span
            >
          </div>
        </rich-form-item>
        <div
          v-if="field.description && Array.isArray(field.description)"
          class="custom-description"
        >
          <p
            v-for="(desc, index) in field.description"
            class="desc-item"
            :key="index"
          >
            * {{ desc }}
          </p>
        </div>
      </div>
    </rich-form-group>
    <rich-form-group v-if="hasSubmit">
      <rich-button @click="submitHandler">提交</rich-button>
    </rich-form-group>

    <!-- viewer instance -->
    <viewer :images="previewImages" @inited="initViewer">
      <template slot-scope="scope">
        <div class="viewer-placehold" v-show="false">
          <img v-for="src in scope.images" :src="src" :key="src" />
        </div>
      </template>
    </viewer>
  </rich-form>
</template>

<script type="text/ecmascript-6">
import { cloneDeep, get } from 'lodash-es'
import MultiSelect from '../MultiSelect'
import MultiSelectNew from '../MultiSelectNew'
import MultiPhone from '../MultiPhone'
import PhoneInput from '../PhoneInput'
import PoiPicker from '../PoiPicker'
import DatePicker from '../DatePicker.vue'
import BizTime from '../BizTime.vue'
import TimeRangePicker from '../TimeRangePicker.vue'
import ExtInfo from '../ExtInfo.vue'
import ReasonSelect from '../ReasonSelect.vue'

import PlatformCheckbox from '../PlatformCheckbox.vue'
import CPFInput from '../CPFInput.vue'
import AccountLastNameInput from '../AccountLastNameInput.vue'
import PostCode from '../PostCode.vue'
// 门店距离
import Distance from '../Distance.vue'
import CountryPicker from '../CountryPicker'
import BirthDate from '../BirthDate'
import BankSelect from '../BankSelect'
import BankBranchSelect from '../BankBranchSelect'
import StartUpCost from '@/components/StartUpCost'
// visit
import visitSelProp from '../VisitSelProp.vue'
import sugSelect from '../SugSelect.vue'
import cascadeChecker from '../CascadeChecker.vue'
import DatePickerInput from '../DatePickerInput.vue'
import CheckVisitTime from '@/pages/visit/addvisitplan/checkVisitTime.vue'
import { sprintf } from '@didi/gettext'
import { prefixUrl, getCommonParams } from '@/common/utils/request'
import compress from '@/common/utils/image'
import { trackEvent } from '@/common/utils/log'
import { url2localProtocol } from '@/common/utils/util'
import DuplicateBizoppCheckbox from '@/components/DuplicateBizoppCheckbox.vue'
import businessChannelSelect from '@/pages/visit/addvisit/OpportunityInfo/components/businessChannelSelect.vue'
import didiPriceRelateOthersSelect from '@/pages/visit/addvisit/OpportunityInfo/components/didiPriceRelateOthersSelect.vue'
import areaMainOpportunitySelect from '@/pages/visit/addvisit/OpportunityInfo/components/areaMainOpportunitySelect.vue'
import isHasOtherStore from '@/pages/visit/addvisit/OpportunityInfo/components/isHasOtherStore.vue'
import VisitObject from '@/pages/visit/addvisit/baseInfo/components/VisitObject.vue'

// viewer 预览
import Viewer from 'v-viewer/src/component'

// 自定义联动查询按钮
import ActionWithUrl from '@/components/ActionWithUrlT'

const INPUT_FOUSE_EVENT = 'input-focus'
const INPUT_BLUR_EVENT = 'input-blur'
const MAX_FILESIZE = 10
const COMPRESS_FILESIZE = 0.1
const COMPONENTS_MAP = {
  multiPhone: MultiPhone,
  multiSelect: MultiSelect,
  multiSelectNew: MultiSelectNew,
  phone: PhoneInput,
  poi: PoiPicker,
  datetime: DatePicker,
  bizTime: BizTime,
  timeRangePicker: TimeRangePicker,
  extInfo: ExtInfo,
  platformCheckbox: PlatformCheckbox,
  reasonSelect: ReasonSelect,
  CPFInput: CPFInput,
  // 邮编
  postCode: PostCode,
  // 拜访记录-门店距离
  distance: Distance,
  // 时区选择
  countryPicker: CountryPicker,
  // 出生日期
  birthDate: BirthDate,
  // 银行搜索
  bankSelect: BankSelect,
  // 支行搜索
  bankBranchSelect: BankBranchSelect,
  // 商机无效多选
  duplicateBizoppCheckbox: DuplicateBizoppCheckbox,
  // 日本-账户名称
  accountLastNameInput: AccountLastNameInput,
  // 日本-启动费
  startUpCostSelect: StartUpCost,
  // 拜访 选择
  visitSelProp: visitSelProp,
  // sug select
  sugSelect: sugSelect,
  // 一级单选/多选，二级单选
  cascadeChecker: cascadeChecker,
  datePickerInput: DatePickerInput,
  checkVisitTime: CheckVisitTime,
  actionWithUrl: ActionWithUrl,

  // 拜访业务相关(之后优化)
  businessChannelSelect: businessChannelSelect,
  didiPriceRelateOthersSelect: didiPriceRelateOthersSelect,
  areaMainOpportunitySelect: areaMainOpportunitySelect,
  isHasOtherStore: isHasOtherStore,
  VisitObject: VisitObject
}
window.SODA_UPLOAD_FILES = {}
export default {
  name: 'SodaForm',
  provide () {
    return {
      rootForm: this
    }
  },
  components: {
    Viewer
  },
  props: {
    value: {
      required: true,
      type: Object,
      default: () => { }
    },
    options: {
      required: false,
      type: Object,
      default: () => {
        return {
          layout: 'classic'
        }
      }
    },
    config: {
      required: true,
      type: Array,
      default: () => []
    },
    hasSubmit: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalData: cloneDeep(this.value),
      compressOptions: {
        type: 'file',
        compress: {
          width: 1600,
          height: 1600,
          quality: 0.2
        }
      },
      previewImages: [],
      configFetchs: [],
      fields: [],
      cropperVisible: false,
      imageData: ''
    }
  },
  created () {
    // 确保动态表单项的properties被监听（TODO：处理后不再生效，可废弃）
    this.config.map(function ({ prop, type }) {
      if (!this.internalData.hasOwnProperty(prop)) {
        if (type === 'custom-upload') {
          this.$set(this.internalData, prop, [])
        } else {
          this.$set(this.internalData, prop, undefined)
        }
      }
    }, this)
  },
  watch: {
    internalData: {
      deep: true,
      handler (nVal) {
        this.$emit('input', nVal)
      }
    },
    config: {
      handler: async function (val, oldVal) {
        const self = this
        let config = this.config.map((item) => {
          this.defaultInternalData()
          let data = {
            modelKey: item.prop
          }
          if (item.type === 'custom-upload') {
            let props = item.props || {}
            let commonParams = getCommonParams()
            let upParams = get(props, 'params', {})
            let path = props.path
            let target = ''
            if (path) {
              target = prefixUrl('common.uploadPrivatePic')
              upParams = {
                bizType: 'crm', // 默认设置bizType为crm
                ...upParams
              }
            } else {
              target = prefixUrl(path || 'common.uploadPublicPic')
            }
            data.props = {
              max: props.max || 1,
              accept: props.accept || 'image/jpeg, image/jpg, image/png',
              multiple: props.multiple || false,
              customCropper: item.customCropper,
              transformWebp: item.transformWebp,
              // auto: false,
              // compress
              processFile (file, next) {
                // 记录原始size
                if (!file.hasCompressed) {
                  compress(file, self.compressOptions, next)
                } else {
                  next(file)
                }
              },
              action: {
                target,
                fileName: 'upfile',
                data: {
                  ...commonParams,
                  ...upParams
                },
                checkSuccess (res, file) {
                  if (res.errno === 0 && res.data) {
                    return true
                  } else if (res.data && res.data.redirectUrl) {
                    self.$createToast({
                      type: 'warn',
                      time: 1000,
                      txt: res.errmsg
                    }).show()
                    /* eslint-disable */
                    setTimeout(() => {
                      location.href = res.data.redirectUrl
                    }, 1000)
                  } else {
                    let fileKey = get(file, 'file.fileKey', '')
                    if (fileKey) {
                      const now = new Date().getTime()
                      trackEvent('sailing_gattarman_x_api_image_upload_error', {
                        name: file.name,
                        originalSize: window.SODA_UPLOAD_FILES[fileKey].originalSize,
                        compressedSize: file.size,
                        diff: now - window.SODA_UPLOAD_FILES[fileKey].start,
                        traceId: res.traceId
                      })
                      delete window.SODA_UPLOAD_FILES[fileKey]
                    }
                    setTimeout(() => {
                      self.$createToast({
                        type: 'warn',
                        time: 1000,
                        txt: self.gettext('上传失败，请重新上传')
                      }).show()
                    }, 0)
                    return false
                  }
                }
              }
            }
            const currentLength = (self.internalData[item.prop] || []).length
            data.events = {
              'file-click': this.fileClickHandler,
              // 'files-added': this.filesAddedHandler(item.size, currentLength, props.max),
              'files-added': this.filesAddedHandler(item.size, currentLength, props.max, item, target),
              'file-success': this.fileSuccessHandler(this.internalData[item.prop], item.formatter)
            }
            data.type = 'upload'

          } else if (Object.keys(COMPONENTS_MAP).indexOf(item.type) > -1) {
            data.component = COMPONENTS_MAP[item.type]
          }
          if (item.type === 'input') {
            item.events = {
              focus: e => {
                this.owner.$emit(INPUT_FOUSE_EVENT, { e })
              },
              blur: e => {
                this.$emit(INPUT_BLUR_EVENT, { e, prop: item.prop })
              },
              ...(item.extEvents || {})
            }
          }
          if (item.type === 'select') {
            item.events = {
              input: value => {
                // 这里和 watch: {internalData} 会重复触发 $emit:input。这么做的目的是为了获取到 selectchange 时的prop，供外部使用
                this.$emit('input', this.internalData, { prop: item.prop })
              }
            }
          }
          // 特殊处理textarea，修改rich-ui属性默认值
          if (item.type === 'textarea') {
            item.events = {
              focus: e => {
                this.owner.$emit(INPUT_FOUSE_EVENT, { e })
              }
            }
            if (!item.props)
              item.props = {}
            item.props['maxlength'] = 300
          }
          if (item.fetch) {
            this.configFetchs.push({
              key: item.prop,
              action: item.fetch
            })
          }
          return Object.assign({}, item, data)
        })
        // 集中处理请求的option
        if (this.configFetchs.length > 0) {
          const fetchData = await this.fetchAll()
          config.forEach(item => {
            if (fetchData[item.prop]) {
              item.props = Object.assign({}, item.props, fetchData[item.prop])
            }
          })
        }
        this.fields = config
      },
      immediate: true
    }
  },
  computed: {
    owner() {
      return this.$parent
    },
  },
  methods: {
    // 确保动态表单项的properties被监听
    defaultInternalData() {
      this.config.map(({ prop, type }) => {
        if (!this.internalData.hasOwnProperty(prop)) {
          // 初始化处理上传图片组件为[]
          if (type === 'custom-upload') {
            this.$set(this.internalData, prop, [])
          } else {
            this.$set(this.internalData, prop, undefined)
          }
        }
        // 初始化处理上传图片组件为[]
        if (type === 'custom-upload' && !this.internalData[prop]) {
          this.$set(this.internalData, prop, [])
        }
      })
    },
    fetchAll() {
      const allFetch = this.configFetchs.map(item => {
        return new Promise((resolve, reject) => {
          item.action().then(res => {
            resolve(res)
          })
        })
      })
      return new Promise((resolve, reject) => {
        Promise.all([
          ...allFetch
        ]).then(res => {
          const result = {}
          res.forEach((itm, i) => {
            result[this.configFetchs[i].key] = itm
          })
          resolve(result)
        })
      })
    },
    initViewer(viewer) {
      this.$viewer = viewer
    },
    showPic(url) {
      this.$createImagePreview({
        imgs: [url]
      }).show()
    },
    validate(cb) {
      return this.$refs.form.validate(cb)
    },
    getValidity() {
      return this.$refs.form.validity
    },
    reset() {
      this.$refs.form.reset()
    },
    submitHandler() {
      this.validate(res => {
        console.log(res)
      })
    },
    checkVisible(field) {
      if (field.checkVisible) {
        return field.checkVisible.call(null, this.value)
      } else {
        return field.visible !== undefined
          ? Boolean(field.visible)
          : true
      }
    },
    fileClickHandler(file) {
      const url = file.customUrl || file.url || ''
      if (url) {
        try {
          this.previewImages = [url2localProtocol(url)]
          setTimeout(() => {
            this.$viewer.show()
          }, 100)
        } catch (err) {
          console.error(err)
          // 自带preview垫底
          this.$createImagePreview({
            imgs: [url]
          }).show()
        }
      }
    },
    filesAddedHandler(maxSize = MAX_FILESIZE * 1024 * 1024, currentLength, maxLength, item, target) {
      let self = this
      return function (files) {
        files = Array.from(files)
        let hasIgnore = false

        if (files.length + currentLength > maxLength) {
          files.splice(maxLength)
        }
        for (let file of files) {
          // 唯一标志
          file.fileKey = `${file.name}${new Date().getTime()}`
          file.hasCompressed = file.size < COMPRESS_FILESIZE * 1024 * 1024
          if (file.size > maxSize) {
            file.ignore = true
            hasIgnore = true
          }
          window.SODA_UPLOAD_FILES[file.fileKey] = {
            start: new Date().getTime(),
            originalSize: file.size
          }
        }
        hasIgnore && self.$createToast({
          type: 'warn',
          time: 1000,
          txt: sprintf(self.gettext('上传照片不能超过%dMB，请重新上传'), MAX_FILESIZE)
        }).show()
        if(!!get(item, 'customCropper.flag', false)){
          self.$createFullCutPicture({
            file: files[0],
            item: item,
            target: target
          }).show()
        }
      }
    },
    fileSuccessHandler(target, formatter) {
      let self = this
      return function (file) {
        // upload success 埋点
        target.forEach(item => {
          const fileKey = get(item, 'file.fileKey', '')
          if (fileKey && window.SODA_UPLOAD_FILES[fileKey]) {
            const now = new Date().getTime()
            trackEvent('sailing_gattarman_x_api_image_upload_timing', {
              start: window.SODA_UPLOAD_FILES[fileKey].start,
              end: now,
              diff: now - window.SODA_UPLOAD_FILES[fileKey].start,
              traceId: file.response.traceId,
              originalSize: window.SODA_UPLOAD_FILES[fileKey].originalSize,
              compressedSize: file.size
            })
            delete window.SODA_UPLOAD_FILES[fileKey]
          }
        })
        const handler = formatter || function (file) {
          return {
            customUrl: file.response.data.url || file.url
          }
        }
        let targetIndex = target.findIndex(i => (i.file || {}).fileKey === file.file.fileKey)
        targetIndex = targetIndex === -1 ? 0 : targetIndex
        self.$set(target, targetIndex, {
          ...file,
          ...handler(file)
        })
      }
    },
    computeCounts(field) {
      return ` (${get(this.internalData, field.prop, []).length}/${field.props.max})`
    }
  }
}
</script>

<style lang="scss">
.soda-bd-form {
  .rich-form-label {
    color: $color-dark-grey;
    font-size: $fontsize-large;
    align-items: flex-start;
    .subTitle {
      display: block;
      font-size: $fontsize-small;
      color: $color-light-grey;
      // margin-left: 20px;
    }
    .counts,
    .link {
      font-size: $fontsize-medium;
      color: $color-light-grey;
    }
    .desc {
      color: #666;
      font-size: $fontsize-medium;
    }
    .link {
      position: absolute;
      right: 15px;
    }
  }
  .level2 {
    .rich-form-label {
      color: $color-grey;
      font-size: $fontsize-medium;
      padding-bottom: 10px;
    }
  }
  .horizontal {
    .rich-form-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .rich-form-label {
        display: inline-block;
        padding-bottom: 0;
      }
      .rich-form-field {
        display: inline-block;
        font-size: $fontsize-medium;
      }
      .rich-checker-item {
        &::after {
          border: 1px solid $color-grey;
        }
      }
      .rich-checker-item_active {
        &::after {
          border: 1px solid $color-dark-orange;
        }
      }
    }
    .rich-form-item_required {
      .rich-form-label:before {
        display: inline;
      }
    }
  }
  .rich-radio-group[data-horz="true"] {
    .rich-radio {
      flex: auto;
      width: auto;
    }
  }
  .viewer-placehold {
    position: fixed;
    top: 0;
    z-index: -1;
  }
}

.custom-description {
  padding: 0 30px;
  font-size: 0.8em;
  .desc-item {
    margin-bottom: 20px;
  }
}
</style>